export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/seasonal.9bb2b30.svg";